import { getValueByProp } from "@supplier/utils";
import { DATETIME_PICKER_FORMAT, DATE_PICKER_FORMAT, DEFAULT_VALUE } from "@supplier/constants";
import moment, { Moment } from "moment/moment";

/**
 * @description 生成唯一 uuid
 * @returns {String}
 */
export function generateUUID() {
    let uuid = "";
    for (let i = 0; i < 32; i++) {
        const random = Math.trunc(Math.random() * 16);
        if (i === 8 || i === 12 || i === 16 || i === 20) uuid += "-";
        uuid += (i === 12 ? 4 : i === 16 ? (random & 3) | 8 : random).toString(16);
    }
    return uuid;
}

export const $get = getValueByProp;

/**时间格式化 */
export const dateFormat = (str?: string | Date | Moment, format: string = DATE_PICKER_FORMAT) =>
    str ? moment(str).format(format).replace("Invalid date", DEFAULT_VALUE) : DEFAULT_VALUE;
export const dateTimeFormat = (str?: string | Date | Moment, format: string = DATETIME_PICKER_FORMAT) =>
    str ? moment(str).format(format).replace("Invalid date", DEFAULT_VALUE) : DEFAULT_VALUE;
/**
 * @description: 判断值是否未某个类型
 */
export function is(val: unknown, type: string) {
    return Object.prototype.toString.call(val) === `[object ${type}]`;
}

/**
 * @description:  是否为数值
 */
export function isNumber(val: unknown): val is number {
    return is(val, "Number");
}

// 千分位格式化数据
export function formatThousandSeparator(
    transactionAmount: string | number | null | undefined,
    decimalPlaces: number = 2,
    showDefaultValue: boolean = false
): string {
    if (transactionAmount === 0) return transactionAmount.toFixed(decimalPlaces);
    if (transactionAmount && isNumber(transactionAmount)) {
        transactionAmount = transactionAmount.toFixed(decimalPlaces);
        return transactionAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return showDefaultValue ? DEFAULT_VALUE : "0";
}

type DaiBanQueryValue = string | number | boolean | string[] | number[] | boolean[] | null | undefined;
type DaiBanQueryParams = Record<string, DaiBanQueryValue>;

// 待办跳转常用的状态字段名
const DAI_BAN_STATE_KEYS = ["states", "state", "status", "deliverStatus", "webState"] as const;

// 从待办跳转列表页，获取缓存的完整查询参数
export const getDaiBanQueryParams = (routerName: string): DaiBanQueryParams => {
    try {
        const obj = JSON.parse(localStorage.getItem("MyTaskGotoList") || "{}") as Record<string, unknown>;
        const queryParams = obj[routerName];
        if (!queryParams || typeof queryParams !== "object" || Array.isArray(queryParams)) return {};
        return queryParams as DaiBanQueryParams;
    } catch {
        return {};
    }
};

// 将待办状态字段统一转成搜索组件需要的数组
const normalizeDaiBanState = (value: DaiBanQueryValue): Array<string | number | boolean> => {
    if (Array.isArray(value)) return value;
    if (value === null || value === undefined) return [];
    return [value];
};

// 从待办跳转列表页，获取缓存状态
export const getDaiBanState = (routerName: string) => {
    const queryParams = getDaiBanQueryParams(routerName);
    const stateKey = DAI_BAN_STATE_KEYS.find(key => queryParams[key] !== undefined && queryParams[key] !== null);
    return stateKey ? normalizeDaiBanState(queryParams[stateKey]) : [];
};

// 下拉框清空待办状态
export const clearDaiBanState = (vals: number[], routerName: string) => {
    if (getDaiBanState(routerName)?.length && !vals.length) {
        localStorage.removeItem("MyTaskGotoList");
    }
};
